import { observer } from 'mobx-react';
import { useAgentSearch } from '../AgentSearchContext';
import IconButton, { ICON_BUTTON_ICONS } from '../../../buttons/IconButton';

const AgentSearchInput = observer(({ placeholder = 'Search...' }) => {
  const searchState = useAgentSearch();

  const handleInputChange = (e) => {
    searchState.setSearchQuery(e.target.value);
  };

  const handleClearSearch = () => {
    searchState.setSearchQuery('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      searchState.closeModal();
    }
  };

  return (
    <div className="agent-search-input">
      <div className="agent-search-input-wrapper">
        <div className="agent-search-input-icon">
          <IconButton
            icon={ICON_BUTTON_ICONS.SEARCH}
            withFill={false}
            withBorder={false}
            disabled={true}
          />
        </div>
        <input
          type="text"
          value={searchState.searchQuery}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          className="agent-search-input-field"
          autoFocus
        />
        {searchState.searchQuery && (
          <div className="agent-search-input-clear">
            <IconButton
              icon={ICON_BUTTON_ICONS.CLOSE}
              onClick={handleClearSearch}
              tooltipText="Clear search"
              tooltipPosition="bottom"
              withFill={false}
              withBorder={false}
            />
          </div>
        )}
      </div>
    </div>
  );
});

export default AgentSearchInput;